// extracted by mini-css-extract-plugin
export default {"confirmCardBtn":"bba-z","disabled":"cba-z","label":"dba-z"};